module.exports = __webpack_public_path__ + "img/bloom_logo.25d8accf.svg";